export const destinationEntities = [
  "Clients",
  "Engagements",
  "Contacts",
  "Users",
];

export const sourceSystems = [
  {
    code: "PIERS",
    label: "PIERS Standard",
    shortLabel: "PIERS",
    description: "Standard PIERS-defined import structure.",
    formats: [
      { code: "XLSX", label: "Excel (.xlsx)", enabled: true },
      { code: "CSV", label: "CSV (.csv) — Coming Soon", enabled: false },
    ],
  },
  {
    code: "CCH",
    label: "CCH ProSystem fx Engagement",
    shortLabel: "CCH",
    description: "Engagement data originating from CCH.",
    formats: [
      { code: "XLSX", label: "Excel (.xlsx)", enabled: true },
      {
        code: "CCH_NATIVE",
        label: "Native CCH Format — Coming Soon",
        enabled: false,
      },
      { code: "XML", label: "XML (.xml) — Planned", enabled: false },
      { code: "API", label: "API Integration — Planned", enabled: false },
    ],
  },
  {
    code: "CASEWARE",
    label: "Caseware",
    shortLabel: "Caseware",
    description: "Client or engagement data originating from Caseware.",
    formats: [
      { code: "XLSX", label: "Excel (.xlsx)", enabled: true },
      { code: "CSV", label: "CSV (.csv) — Coming Soon", enabled: false },
      {
        code: "CASEWARE_NATIVE",
        label: "Native Caseware Format — Coming Soon",
        enabled: false,
      },
      { code: "XML", label: "XML (.xml) — Planned", enabled: false },
      { code: "API", label: "API Integration — Planned", enabled: false },
    ],
  },
  {
    code: "CUSTOM",
    label: "Custom / Other",
    shortLabel: "Custom / Other",
    description: "Firm-specific or third-party data structure.",
    formats: [
      { code: "XLSX", label: "Excel (.xlsx)", enabled: true },
      { code: "CSV", label: "CSV (.csv) — Coming Soon", enabled: false },
      { code: "XML", label: "XML (.xml) — Planned", enabled: false },
      { code: "JSON", label: "JSON (.json) — Planned", enabled: false },
    ],
  },
];

export const getSourceSystem = (code) =>
  sourceSystems.find((source) => source.code === code) || sourceSystems[0];
export const getEnabledFormat = (sourceCode) =>
  getSourceSystem(sourceCode).formats.find((format) => format.enabled)?.code ||
  "";
export const getFormatLabel = (sourceCode, formatCode) =>
  getSourceSystem(sourceCode)
    .formats.find((format) => format.code === formatCode)
    ?.label?.replace(/\s+—.+$/, "") || formatCode;
